<rk-modal-wrapper
  (submitted)="onSubmit()"
  (cancelled)="closeSelf()"
  (closed)="closeSelf()"
  [title]="'SCHEDULE.PLANNING.MOVE_MODAL_TITLE' | translate : { title: event.title }"
  [submitText]="'SCHEDULE.PLANNING.MOVE_MODAL_SUBMIT' | translate"
  [loading]="isLoading$ | async"
  [hideCancelOnLoading]="true"
>
  <mat-radio-group class="flex flex-col !mt-0" [(ngModel)]="moveAll">
    <mat-radio-button [value]="false">
      <span translate>SCHEDULE.PLANNING.MOVE_MODAL_ONLY_THIS</span>
    </mat-radio-button>
    <mat-radio-button [value]="true">
      <span translate>SCHEDULE.PLANNING.MOVE_MODAL_ALL</span>
    </mat-radio-button>
  </mat-radio-group>
</rk-modal-wrapper>
